import React, { useEffect, useState } from 'react';
import { PolicyModel } from '../models/superbit-api-models';
import moment from 'moment';
import ClientPolicy from './_ClientPolicy';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSquareMinus, faSquarePlus } from '@fortawesome/free-regular-svg-icons';
import ClientPolicyRider from './_ClientPolicyRider';


type Props = {
    isSelected: boolean,
    policyItems: any[];
    config: any;
    showAddTreatmentPopup: (type: number) => void;
    customerData: any;
};

const ClientPolicyItem = (props: Props) => {
    const [parentIem, seParentItem] = useState<any>(undefined);
    const [children, setChldreen] = useState<any[]>([]);
    const [open, setOpen] = useState<boolean>(false);
    // const [policyItemItem, setPolicyitem] = useState<any>(props.policyDetails);
    // const [policyNumber, setPolicyNumber] = useState<string>(props.policyDetails.subscriberNumber)
    // const [apiUrl, setApiUrl] = useState<string>('');

    useEffect(() => {
        // const aUrl = localStorage.getItem('apiUrl');
        // if (apiUrl == '' && aUrl) {
        //     setApiUrl(aUrl);
        // }
        // console.log('ClientPolicyItem', props.policyItems);
        // if (policyItemItem.riderPackages && policyItemItem.riderPackages.subscriberNumber) {
        //     setPolicyNumber(policyItemItem.riderPackages.subscriberNumber);
        // }
        // const 
    }, [props])

    useEffect(() => {
        // console.log('policy item init', props.policyItems);
        if (props.policyItems[0].itemType == 'rider') {


            seParentItem(props.policyItems[0]);
            if (props.policyItems.length > 0) {
                const items: any[] = [];
                for (let index = 1; index < props.policyItems.length; index++) {
                    items.push(props.policyItems[index]);
                }
                setChldreen(items);
            }
        }
        else {

            if (props.policyItems.length > 0) {
                const items: any[] = [];
                let lastPolicy = null;
                let sum = 0;

                for (let index = props.policyItems.length-1; index >= 0; index--) {
                    items.push(props.policyItems[index]);
                    lastPolicy = { ...props.policyItems[index] };
                    sum += lastPolicy.policyAdditionDetails.premiumSum;
                }

                setChldreen(items);
                const firstPolicy = { ...items[0]};
                // Deep clone to avoid nested reference sharing
                const _parentItem = structuredClone(lastPolicy);
                _parentItem.additionNumber = '';
                _parentItem.startDate = new Date(firstPolicy.startDate);
                _parentItem.extensionStartDate = new Date(firstPolicy.startDate);
                
                _parentItem.endDate = new Date(firstPolicy.endDate);
                _parentItem.extensionEndDate = new Date(firstPolicy.endDate);
                _parentItem.policyAdditionDetails.premiumSum = sum;

                seParentItem(_parentItem);
            }

        }
    }, [])


    const emptyFunc = () => { }

    const onIconClick = () => {
        // console.log('onIconClick');
        setOpen(!open);
    }

    if (parentIem) {
        if (parentIem.itemType == 'rider') {
            return (
                <>



                    <ClientPolicyRider policyDetails={parentIem}
                        isSelected={props.isSelected}
                        config={{
                            showRightCell: false,
                            hasChildren: children.length > 0 ? true : false,
                            parent: children.length > 0 ? true : false,
                            open: open,
                            index: children.length,
                            additionalColumns: props.config.additionalColumns,
                            onIconClick: () => onIconClick(),
                            onSelectPolicy: (id: string | null) => props.config.onSelectPolicy(id),
                            onClaimCreate: (id: string | null, data?: any) => props.config.onClaimCreate(id, data)
                        }}
                        showAddTreatmentPopup={props.showAddTreatmentPopup}
                        displayFile={(documentUrl: string) => props.config.displayFile(documentUrl)}
                        customerData={props.customerData}
                    />
                    <div className={`${open ? '' : 'hide'}`}>
                        {children.map((policy: any, index: number) =>
                            <>
                                <ClientPolicyRider policyDetails={policy} config={{
                                    index: index,
                                    isFirst: true,
                                    showRightCell: true,
                                }}
                                    showAddTreatmentPopup={props.showAddTreatmentPopup}
                                    displayFile={(documentUrl: string) => props.config.displayFile(documentUrl)}
                                    customerData={props.customerData}
                                />
                            </>
                        )}
                    </div>
                </>
            )
        } else {
            if (parentIem.itemType == 'policy') {
                return (
                    <>
                        <ClientPolicy policyDetails={parentIem}
                            isSelected={false}
                            config={{
                                showRightCell: false,
                                hasChildren: children.length > 1 ? true : false,
                                parent: children.length > 1 ? true : false,
                                open: open,
                                index: children.length,
                                additionalColumns: props.config.additionalColumns,
                                onIconClick: () => onIconClick(),
                                onSelectPolicy: (id: string | null) => props.config.onSelectPolicy(id),
                                onClaimCreate: (id: string | null, data?: any) => props.config.onClaimCreate(id, data)
                            }}
                            showAddTreatmentPopup={props.showAddTreatmentPopup}
                            displayFile={(documentUrl: string) => props.config.displayFile(documentUrl)}
                            customerData={props.customerData}
                        />
                        <div className={`${open ? '' : 'hide'}`}>
                            {children.length > 1 && children.map((policy: any, index: number) =>
                                <>
                                    <ClientPolicy policyDetails={policy} config={{
                                        index: index,
                                        isFirst: true,
                                        showRightCell: true,
                                    }}
                                        showAddTreatmentPopup={props.showAddTreatmentPopup}
                                        displayFile={(documentUrl: string) => props.config.displayFile(documentUrl)}
                                        customerData={props.customerData}

                                    />
                                </>
                            )}
                        </div>
                    </>
                )
            } else {
                return (<></>)
            }
        }
    } else {
        return (<></>);
    }
}

export default ClientPolicyItem;